import React, { useEffect, useState, useRef } from 'react'

import Card from './Card'
import './Game.scss'

const shuffleCards = function (arr) {
  const length = arr.length
  for (let i = length; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * i)
    const currentIndex = i - 1
    const temp = arr[currentIndex]
    arr[currentIndex] = arr[randomIndex]
    arr[randomIndex] = temp
  }
  return arr
}

const Game = ({
  gameRunning,
  movesRemaining,
  setMovesRemaining,
  stepCards,
  maxTries,
  onResults,
  onCardClick,
}) => {
  const [cards, setCards] = useState([])
  const [openCards, setOpenCards] = useState([])
  const [clearedCards, setClearedCards] = useState([])

  const timeout = useRef(null)

  const getCardById = id => cards.find(card => card.id === id)

  const doFlippedCardsMatch = (firstCardId, secondCardId) => {
    const { matchingCardId } = getCardById(firstCardId)
    return matchingCardId === secondCardId
  }

  const handleResults = results => {
    console.log(`trigger results" ${results}`)
    onResults && onResults(results)
  }

  const checkCompletion = async () => {
    // if (gameRunning === true) {
    //If you've used up your moves or you've won, game over bro.
    //REsults modal shows number of move it took.
    console.log('checkCompletion')
    if (movesRemaining !== null) {
      //or else this gets called before movesRemaining is set.
      if (movesRemaining < 1 || clearedCards.length === stepCards.length) {
        handleResults({
          cardsCleared: clearedCards.length,
          movesRemaining: movesRemaining,
          totalCards: stepCards.length,
        })
      }
    }
    //  }
  }

  //see if flipped cards match
  const evaluate = () => {
    const [firstId, secondId] = openCards
    let bool = doFlippedCardsMatch(firstId, secondId)
    if (bool === true) {
      let prevClearedCards = clearedCards
      setClearedCards([...prevClearedCards, firstId, secondId])
      setOpenCards([])
    } else {
      let newMovesNumber = moves => moves - 1
      setMovesRemaining(newMovesNumber)
    }
    // This is to flip the cards back after 500ms duration
    timeout.current = setTimeout(() => {
      setOpenCards([])
    }, 500)
  }

  const handleCardClick = cardId => {
    if (openCards.length === 1) {
      let openCards = prev => [...prev, cardId]
      setOpenCards(openCards)
      onCardClick && onCardClick({ cardClicked: cardId })
    } else {
      clearTimeout(timeout.current)
      setOpenCards([cardId])
      onCardClick && onCardClick({ cardClicked: cardId })
    }
  }

  useEffect(() => {
    let timeout = null

    if (openCards.length === 2) {
      timeout = setTimeout(evaluate, 300)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [openCards])

  useEffect(() => {
    checkCompletion()
  }, [clearedCards, movesRemaining])

  const checkIsFlipped = cardId => {
    return openCards.includes(cardId)
  }

  const checkIsInactive = cardId => {
    if (clearedCards.length > 0) {
      return clearedCards.includes(cardId)
    } else {
      return false
    }
  }

  const handleStart = () => {
    setClearedCards([])
    setOpenCards([])
    setMovesRemaining(maxTries)
    // set a shuffled deck of cards
    setCards(shuffleCards(stepCards))
  }

  //Watch for parent state changes, then trigger go. this is also an unprofessional "loading" indicator
  useEffect(() => {
    if (gameRunning === true) {
      //Start game
      console.log('Game begins')
      handleStart()
    }
  }, [gameRunning])

  return (
    <>
      <div
        className={`flex-container ${
          gameRunning ? `game-enabled` : `game-over`
        }`}
      >
        {!!cards.length &&
          cards.map((card, index) => {
            const frontImage = card.frontImage || ''
            const { rearImage, id: cardId } = card
            return (
              <Card
                cardsCount={cards.length}
                disabled={gameRunning !== true}
                key={`card--${cardId}`}
                cardId={cardId}
                rearImage={rearImage}
                frontImage={frontImage}
                isInactive={checkIsInactive(cardId)}
                isFlipped={checkIsFlipped(cardId)}
                onClick={handleCardClick}
              />
            )
          })}
      </div>
    </>
  )
}
export default Game
